import { combineReducers } from 'redux'
import OauthConfigReducer from './OauthConfigReducer'
import SessionReducer from './SessionReducer'
import ResetPasswordReducer from './ResetPasswordReducer'

export default combineReducers({
  oauthConfig: OauthConfigReducer,
  session: SessionReducer,
  resetPassword: ResetPasswordReducer
})
